<template>
  <div id="form" class="bottom">
    <p class="montserrat" id="subhead" style="text-align: center;">Learn from the ground up</p>
    <form id="test-form">
      <div>
        <input
          type="email"
          id="email"
          name="email"
          placeholder="Interested?"
          class="input-text mont underlined vcenter"
          autocomplete="off"
        />
        <button type="submit" id="submit-form" class="vcenter hide">Join</button>
      </div>
    </form>
  </div>
</template>
    
<script>
export default {
 name: "emailForm"
}
</script>
    
<style>
.input-text {
  display: block;
  margin: 0;
  margin-bottom: 0.8rem;
  padding: 0.5rem 1rem;
  color: #8e2cea;
  border: none;
  background-color: white;
  width: 20rem;
  font-family: inherit;
  font-size: 1rem;
  font-weight: inherit;
  line-height: 1rem;
  border-radius: 0.5rem;
  transition: box-shadow 0.5s;
  transition: background-color 0.5s;
  text-align: center;
  overflow: visible;
  caret-color: #f9564f;
  -webkit-appearance: none;
}

#submit-form {
  display: block;
  padding: 0.5rem 0rem;
  border: none;
  width: 20rem;
  font-family: inherit;
  font-size: 1rem;
  font-weight: inherit;
  line-height: 1rem;
  border-radius: 0.4rem;
  text-align: center;
}

#submit-form:focus {
  outline: 0;
}

.underlined::placeholder {
  text-decoration: underline;
}

.done::placeholder {
  color: #8e2cea;
}

.input-text::placeholder {
  color: #8e2cea;
  text-align: center;
}

.input-text:focus::placeholder {
  color: #8e2cea;
}

.hide {
  background-color: white;
  color: white;
  transition: background-color 0.5s;
}

#submit-form:not(.hide) {
  color: white;
  background-color: #8e2cea;
  transition: background-color 0.5s;
}

#submit-form:not(.hide):hover {
  background-color: #8e2cea;
  box-shadow: 0rem 0.2rem 0.3rem #00000077;
}

.input-text:focus {
  outline: none;
  border: none;
  box-shadow: 0rem 0rem 0.6rem #00000077;
}

.input-text:focus:hover {
  box-shadow: 0rem 0rem 0.6rem #00000099;
}

.input-text:hover {
  outline: none;
  transition: box-shadow 0.5s;
  transition: background-color 0.5s;
  box-shadow: 0rem 0rem 0.6rem #00000099;
}

.center-form {
  margin: 0;
  position: absolute;
  width: 100%;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -100%);
  transition: top 0.6s;
}

.mont {
  font-weight: 300;
  color: #8e2cea;
}

.mont:focus {
  color: #8e2cea;
}

.montserrat {
  font-weight: 300;
  font-size: 20px;
  color: #8e2cea;
  font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
}

@media screen and (max-width: 500px) {
  .montserrat {
    font-weight: 300;
    font-size: 20px;
    color: #8e2cea;
    font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
  }

  .center-form {
    margin: 0;
    position: absolute;
    top: 99%;
    left: 50%;
    transform: translate(-50%, -100%);
    transition: top 0.6s;
  }
}

.bottom {
  margin: 0;
  position: absolute;
  top: 99%;
  left: 50%;
  transform: translate(-50%, -100%);
  transition: top 0.6s;
}
</style>


// WEBPACK FOOTER //
// src/components/emailForm.vue